import { ConfirmationRdv } from '@components/confirmation-rdv/models';
import { Block } from '@shared/models';

export const confirmationRdvMock: Block<ConfirmationRdv> = {
  type: 'confirmation-rdv',
  data: {
    title: {
      text: `Votre rendez-vous est confirmé !`,
      as: 'span',
    },
    subtitle: `Hâte de vous retrouver autour d'un café (un thé ça marche aussi)`,
    questionText: `Pouvez-vous nous dire comment vous nous avez connu ?`,
    answerOptions: [
      {
        key: 'friend',
        label: 'Par un proche',
      },
      {
        key: 'facebook_instagram_ad',
        label: 'Une publicité Facebook ou Instagram',
      },
      {
        key: 'pinterest',
        label: 'Pinterest',
      },
      {
        key: 'influencer',
        label: 'Par un influenceur',
      },
      {
        key: 'search_engine',
        label: 'Un moteur de recherche (Google, Yahoo...)',
      },
      {
        key: 'other',
        label: 'Autre',
      },
    ],
  },
};
